import types from './types';

const mergeEntities = entities => ({
  type: types.MERGE_ENTITIES,
  payload: entities,
});

export default {
  mergeEntities,
};
